import { action, computed, observable, makeObservable } from "mobx";
import UsuarioStore from './UsuarioStore';
import FiltroStore from "./FiltroStore";
import RouterStore from "./RouterStore";

class TopBarStore {
   mostrar = true;
   menuAcoes;
   menuAberto = false;
   tourHabilitado = false;
   acoes;
   anchorEl;
   modoCompacto = false;
   justDevAberto = false;

   setJustDevAberto = (aberto: boolean) => {
      this.justDevAberto = aberto;
   };

   toggleMenu = (event) => {
      if (this.menuAberto === true) {
         this.fechaMenu();
      } else {
         this.abreMenu(event);
      }
   }

   fechaMenu = () => {
      this.menuAberto = false;
   };

   abreMenu = (event) => {
      FiltroStore.drawerIsOpen = false;
      this.menuAberto = true;
      this.anchorEl = event.currentTarget;
   };


   constructor() {
      makeObservable(this, {
         mostrar: observable,
         menuAcoes: observable,
         menuAberto: observable,
         tourHabilitado: observable,
         acoes: observable,
         anchorEl: observable,
         modoCompacto: observable,
         justDevAberto: observable,
         setJustDevAberto: action,
         fechaMenu: action,
         abreMenu: action,
         mostrarControleGabineteSettings: computed,
         titulo: computed
      });
   }


   get mostrarControleGabineteSettings() {
      const rota = RouterStore.rotaAtual || RouterStore.lastRoute || window.location.pathname;
      if (rota === '/controleGabinete') {
         return true;
      }
   }
   get titulo(): string {
      const rota = RouterStore.rotaAtual || RouterStore.lastRoute || window.location.pathname;

      if (rota === '/minutasAssinadas') {
         return 'Minutas Assinadas';
      }
      if (rota === '/parametroSistema') {
         return 'Parâmetros do Sistema';
      }
      if (rota === '/parametroGabinete') {
         return 'Parâmetros do Gabinete';
      }
      if (rota === '/parametroUsuario') {
         return 'Parâmetros do Usuário';
      }
      if (rota === '/escaninho/dashboard') {
         return 'Gerenciamento de Acervo';
      }
      if (rota === '/controleGabinete') {
         return 'Controle de Gabinete';
      }
      if (rota === '/configuracaoGabinete') {
         return 'Configuração do Gabinete ' + (UsuarioStore.gabinete || '');
      }
      if (rota === '/categoria') {
         return 'Categoria de Minutas';
      }
      if (rota === '/modelosMinuta') {
         return 'Modelos de Minutas';
      }
      if (rota === '/variaveis') {
         return 'Variáveis';
      }
      if (rota?.includes('/escaninho')) {
         if (rota.includes('escaninho/gerencial')) {
            return 'Escaninho do Gabinete';
         }
         if (rota.includes('assinatura')) {
            return 'Escaninho de Assinatura';
         }
         if (rota.includes('usuario')) {
            return 'Escaninho do Usuário';
         }
         if (rota.includes('vistos')) {
            return 'Escaninho de Vistos';
         }
         if (rota.includes('filtrado')) {
            return 'Escaninho Filtrado';
         }
         if (rota.includes('julgamento')) {
            return 'Escaninho de Julgamento';
         }
         if (rota.includes('pauta')) {
            return 'Escaninho de Pauta';
         }
         if (rota.includes('peticao')) {
            return 'Escaninho de Petições';
         }
         if (rota.includes('voto-vencido')) {
            return 'Escaninho de Justificativa de voto vencido';
         }
         if (rota.includes('redator-designado')) {
            return 'Escaninho do Redator Designado';
         }
      }

      // HERMES
      if (rota === '/assistenteMinutas/autotextos') {
         return 'Autotextos';
      }
      if (rota === '/assistenteMinutas/estruturas') {
         return 'Estruturas de Minutas';
      }
      if (rota === '/assistenteMinutas/gerenciarMinutas') {
         return 'Gerenciador de Minutas';
      }
      if (rota === '/assistenteMinutas/temas') {
         return 'Temas';
      }
      if (rota === '/assistenteMinutas/modelosTemas') {
         return 'Modelos de Temas';
      }
      if (rota === '/modelosMinuta') {
         return 'Modelos de Minutas';
      }
      return '';
   }
}

export default new TopBarStore();
